export default "__VITE_ASSET__Bblgb_sx__"